export default {
  // 'authenticated','not-authenticated','authenticating'
  status: "not-authenticated",
  usuario: null,
  token: null
};
